<template>
  <div>
    <div v-if="openPopperID != type" @click="openPopper(type)">
      <slot>
        <component
          :is="`${game}-bet-lot-button`"
          :type="type"
          :odd="odd"
          :win="win"
          :game="game"
          :size="size"
          :stake-record-sum="stakeRecordSum"
          :champion-bet="championBet"
          :display="display"
          :display-words="displayWords"
        />
      </slot>
    </div>

    <vue-popper
      v-if="openPopperID == type"
      ref="popper"
      trigger="click"
      :boundaries-selector="'#game-' + gameData.gID"
      :options="popperOptions"
      :force-show="true"
      @documentClick="closePopper(type)"
      @show="popperOnShow(type)"
      @hide="popperHide(type)"
    >
      <div class="popper betlot-popper">
        <div class="betlot-popper-header">
          <Row type="flex" justify="space-between">
            <Col>
              <Row type="flex">
                <b class="betlot-title">{{ gameTitle }}</b>
              </Row>
              <Row>
                <div class="betlot-draw-no">
                  {{ $t("general.draw_no") }} {{ gameData.gCode
                  }}{{ gameData.drawID }}
                </div>
              </Row>
            </Col>
            <Col class="betlot-counter">
              <span>{{ minutesString[0] }}</span>
              <span>{{ minutesString[1] }}</span>
              <span class="betlot-counter-colon">:</span>
              <span>{{ secondsString[0] }}</span>
              <span>{{ secondsString[1] }}</span>
            </Col>
          </Row>
        </div>
        <div v-if="!isShowingResult">
          <div>
            <form class="form">
              <Row type="flex" justify="start">
                <b class="betlot-header-game">
                  <!-- {{
                  $t(`${gameType}.${type}group`)
                  }}-->
                  {{ gametypegroup }}
                </b>
              </Row>

              <Row type="flex">
                <b class="betlot-header-odd">{{ gametype_bet }} @ {{ odd }}</b>
              </Row>

              <div class="inputs">
                <span class="input-stake">
                  <Form
                    ref="betlot-form"
                    :rules="betlotRules"
                    class="input-form"
                  >
                    <FormItem prop="stake">
                      <input
                        :id="'input-stake-' + gameData.gID + '-' + type"
                        class="betlot-actions-components-input"
                        clearable
                        v-model="stake"
                        @keydown="isNumber"
                        @keydown.enter.prevent="betOnClick()"
                        :disabled="pointerCell == 'none'"
                        :readonly="this.$root.app == true"
                      />
                    </FormItem>
                  </Form>

                  <a
                    :style="{ pointerEvents: pointerCell }"
                    @click="clearStake()"
                  >
                    <svg class="icon-close">
                      <use xlink:href="#icon-close" />
                    </svg>
                  </a>

                  <svg style="display: none">
                    <symbol id="icon-close" viewBox="0 0 512 512">
                      <path
                        d="m438 387l-131-131 131-131c14-14 14-36 0-50-15-15-37-15-51 0l-131 130-131-130c-14-15-36-15-50 0-15 14-15 36 0 50l130 131-130 131c-15 14-15 36 0 51 14 14 36 14 50 0l131-131 131 131c14 14 36 14 51 0 14-15 14-37 0-51z"
                      />
                    </symbol>
                  </svg>
                </span>
              </div>

              <div class="quickbet grid-x small-up-4">
                <div
                  class="cell"
                  :style="{ pointerEvents: pointerCell }"
                  v-for="stakestep in gameBet"
                >
                  <a @click="addStakeOnClick(stakestep)"
                    >+{{ commaNumber(stakestep) }}</a
                  >
                </div>
                <div class="cell" :style="{ pointerEvents: pointerCell }">
                  <a @click="setMaxStakeOnClick()" class="max">{{
                    $t("general.max")
                  }}</a>
                </div>
              </div>

              <div v-if="this.rules" class="summary">
                <div class="betlot-bet-info">
                  <div class="error" v-if="error">{{ error }}</div>
                  {{ $t("general.payout") }} :
                  <span class="summary_value">{{ payout }}</span>
                  <br />
                  {{ $t("general.min_to") }} :
                  <span class="summary_value">{{ minbet }}</span>
                  <br />
                  {{ $t("general.max_to") }} :
                  <span class="summary_value">{{ maxbet }}</span>
                  <br /><br />

                  <div
                    class="bet-checking"
                    v-if="
                      this.doubleCheck &&
                        this.numLastStake > 0 &&
                        this.numstake >= this.numLastStake * 2 &&
                        this.$root.showAlert == 1
                    "
                  >
                    <input
                      type="checkbox"
                      id="checkbox"
                      value="checked"
                      v-model="checked"
                    />
                    <label for="checkbox">
                      Proceed betting {{ this.stake }} ? <br />
                      <span style="padding-left: 22px"
                        >(Previous bet is {{ this.$root.lastStake }})</span
                      ></label
                    >
                  </div>
                </div>
              </div>
              <div class="summary" v-else>
                <div class="loading">
                  <div class="loading-icon"></div>
                </div>
              </div>

              <div class="bet-choices">
                <a @click="cancelOnClick" class="cancel-button">{{
                  $t("general.cancel")
                }}</a>
                <Button
                  class="bet-button"
                  :class="
                    this.doubleCheck &&
                    this.numLastStake > 0 &&
                    this.numstake >= this.numLastStake * 2 &&
                    this.$root.showAlert == 1
                      ? 'alert'
                      : ''
                  "
                  @click="betOnClick"
                  :disabled="
                    this.doubleCheck &&
                    this.numLastStake > 0 &&
                    this.numstake >= this.numLastStake * 2 &&
                    checked == false
                      ? true
                      : false
                  "
                  >{{ $t("general.bet") }}</Button
                >
              </div>
            </form>
          </div>
        </div>

        <div class="betlot-bet-response" v-else>
          <Row type="flex" justify="start">
            <b class="betlot-header-game">
              <!-- {{
              $t(`${gameType}.${type}group`)
              }}-->
              {{ gametypegroup }}
            </b>
          </Row>
          <Row type="flex">
            <b class="betlot-header-odd">{{ gametype_bet }} @ {{ odd }}</b>
          </Row>
          <Row class="betlot-bet-response-message" type="flex">{{
            responseMessage
          }}</Row>

          <Row class="betlot-bet-response-ref-no" type="flex"
            >[{{ $t("general.ref") }}: {{ refNo }}]</Row
          >
          <div class="loading" v-if="(isLoading = false)">
            <div class="loading-icon"></div>
          </div>

          <Row type="flex" v-else-if="(isLoading = true)">
            <a @click="okOnClick" class="betlot-actions-components-button"
              >OK</a
            >
          </Row>
        </div>
      </div>
      <div slot="reference">
        <slot>
          <component
            :is="`${game}-bet-lot-button`"
            :type="type"
            :odd="odd"
            :win="win"
            :game="game"
            :size="size"
            :stake-record-sum="stakeRecordSum"
            :champion-bet="championBet"
            :display="display"
            :display-words="displayWords"
          />
        </slot>
      </div>
    </vue-popper>
  </div>
</template>

<script>
import numeral from "numeral";
import VuePopper from "vue-popperjs";
import { toArray, each, filter, sumBy } from "lodash";
import { titleCase } from "change-case";
import EventBus from "../../configs/event-bus";
import {
  Row,
  Col,
  Input,
  Button,
  Form,
  FormItem,
  Message,
  Divider,
} from "iview";
import "vue-popperjs/dist/vue-popper.css";
import axios from "../../configs/axios";
import TaiXiuBetLotButton from "../tai-xiu/widgets/BetLotButton";
import HiLoHighLowBetLotButton from "../hi-lo/widgets/HiLoHighLowBetLotButton";
import GroupBetBetLotButton from "../hi-lo/widgets/GroupBetBetLotButton";
import RedBlackBetBetLotButton from "../hi-lo/widgets/RedBlackBetBetLotButton";
import NumberBetBetLotButton from "../hi-lo/widgets/NumberBetBetLotButton";
import DominoBetLotButton from "../domino/widgets/DominoLotButton";
import MaxRacingBetLotButton from "../max-racing/widgets/MaxRacingBetLotButton";
import FantanNimBetLotButton from "../fantan/widgets/FantanNimBetLotButton";
import FantanNgaBetLotButton from "../fantan/widgets/FantanNgaBetLotButton";
import FantanBetLotButton from "../fantan/widgets/FantanBetLotButton";
import FantanKwokBetLotButton from "../fantan/widgets/FantanKwokBetLotButton";
import FantanSshBetLotButton from "../fantan/widgets/FantanSshBetLotButton";
import ThaiHiloBetLotButton from "../thai-hilo/widgets/ThaiHiloBetLotButton";
import ThaiHiloMainBetLotButton from "../thai-hilo/widgets/ThaiHiloMainBetLotButton";
import ThaiHiloHorizontalBetLotButton from "../thai-hilo/widgets/ThaiHiloHorizontalBetLotButton";
import ThaiHiloVerticalBetLotButton from "../thai-hilo/widgets/ThaiHiloVerticalBetLotButton";
import SeDieBetLotButton from "../se-die/widgets/SeDieBetLotButton";
import {
  betlotInitialState,
  hi_lo_betTypes,
  tai_xiu_betTypes,
  domino_betTypes,
  maxracing_betTypes,
  fantan_betTypes,
  thaihilo_betTypes,
} from "../../configs/global";
import { async } from "q";

export default {
  props: [
    "type",
    "types",
    "odd",
    "win",
    "game",
    "size",
    "gameData",
    "disallowBetting",
    "minutesString",
    "secondsString",
    "rebets",
    "group",
    "stakeRecordSum",
    "norebetlast",
    "previousdrawno",
    "gameType",
    "championBet",
    "category",
    "display",
    "displayWords",
  ],
  components: {
    Row,
    Col,
    Input,
    Button,
    Form,
    FormItem,
    Message,
    Divider,
    VuePopper,
    TaiXiuBetLotButton,
    HiLoHighLowBetLotButton,
    GroupBetBetLotButton,
    RedBlackBetBetLotButton,
    NumberBetBetLotButton,
    DominoBetLotButton,
    MaxRacingBetLotButton,
    FantanNimBetLotButton,
    FantanNgaBetLotButton,
    FantanBetLotButton,
    FantanKwokBetLotButton,
    FantanSshBetLotButton,
    ThaiHiloBetLotButton,
    ThaiHiloMainBetLotButton,
    ThaiHiloHorizontalBetLotButton,
    ThaiHiloVerticalBetLotButton,
    SeDieBetLotButton,
  },
  mounted() {},
  computed: {
    numLastStake() {
      return numeric(this.$root.lastStake);
    },
    numstake() {
      return numeric(this.stake);
    },
    gameTitle() {
      return titleCase(this.gameData.title);
    },
    gametypegroup: function() {
      if (this.gameType == "fantan") {
        this.gametype_category = this.$t(
          `${this.gameType}.${this.category}group`
        );
        return this.gametype_category;
      } else {
        this.gametype_category = this.$t(`${this.gameType}.${this.type}group`);
        return this.gametype_category;
      }
    },
    gametype_bet: function() {
      if (this.gameType == "fantan") {
        if (this.type.charAt(0) == "s") {
          return this.$t(`${this.gameType}.ssh`) + this.type.slice(-3);
        } else if (this.type.charAt(0) == "k") {
          return this.$t(`${this.gameType}.kwok`) + this.type.slice(-2);
        } else if (this.type.charAt(1) == "N") {
          return (
            this.type.slice(0, 1) +
            this.$t(`${this.gameType}.nim`) +
            this.type.slice(-1)
          );
        } else if (this.type.charAt(2) == "N") {
          return (
            this.type.slice(0, 2) +
            this.$t(`${this.gameType}.nga`) +
            this.type.slice(-1)
          );
        } else {
          return this.$t(`${this.gameType}.${this.type}`);
        }
      } else {
        this.gametype_bettype = this.$t(`${this.gameType}.${this.type}`);
        return this.gametype_bettype;
      }
    },

    betID: function() {
      if (this.gameType == "fantan") {
        return this.category.slice(1) + "_" + this.type;
      } else if (this.gameType == "max_racing") {
        if (this.type == "o1") {
          return this.type.slice(1) + "_" + this.championBet;
        } else {
          return this.type.slice(1);
        }
      } else {
        return this.type.slice(1);
      }
    },
    gameTypeID: function() {
      if (this.gameType == "hi_lo") {
        return hi_lo_betTypes[this.type].gameTypeID;
      } else if (this.gameType == "tai_xiu") {
        return tai_xiu_betTypes[this.type].gameTypeID;
      } else if (this.gameType == "domino") {
        return domino_betTypes[this.type].gameTypeID;
      } else if (this.gameType == "max_racing") {
        return maxracing_betTypes[this.type].gameTypeID;
      } else if (this.gameType == "fantan") {
        return fantan_betTypes[this.category].gameTypeID;
      } else if (this.gameType == "thai-hilo") {
        return thaihilo_betTypes[this.category].gameTypeID;
      }
    },
    minbet: function() {
      let minBet = this.rules.data.minbet;
      return numeral(minBet).format("0,0");
    },
    maxbet: function() {
      let maxBet = this.rules.data.maxbet;
      return numeral(maxBet).format("0,0");
    },
    payout: function() {
      return display_numeric(
        parseInt(this.stake.replaceAll(",", "")) * this.gameTypeOdd,
        2
      );
    },
    isSpecificNumber() {
      if (this.gameType == "fantan") {
      } else {
        let gameType = this.type.match(/\d+/gi);
        return gameType[0].length === 2;
      }
    },
    activeGameType() {
      return this[`dice${this.group || 1}SelectedType`];
    },
    gameTypeOdd() {
      if (this.isSpecificNumber) {
        if (!this.gameData.odds) {
          return this.type;
        }
        return this.gameData.odds[this[`dice${this.group}SelectedType`]];
      }
      return this.odd;
    },
  },
  watch: {
    disallowBetting(newVal) {
      if (newVal) {
        if (typeof this.$refs.popper !== "undefined")
          this.$refs.popper.doClose();
      }
    },
    stake: function stake() {
      this.stake = display_numeric(this.stake);
      this.preCheckStake();
    },
  },
  data() {
    return {
      error: null,
      errorTimer: null,
      token: null,
      done: false,
      isLoading: false,
      isShowingResult: false,
      stake: "",
      rules: null,
      betting: false,
      refNo: "",
      doubleCheck: false,
      setStakeTimeout: null,
      closeResponsePopperTimeout: null,
      dice1SelectedType: "o11",
      dice2SelectedType: "o21",
      dice3SelectedType: "o31",
      dice4SelectedType: "o41",
      dice5SelectedType: "o51",
      dice6SelectedType: "o61",
      gameBet: [],
      pointerCell: "auto",
      disabled: false,
      preventDoubleEnter: 0,
      checked: false,
      popperOptions: {
        placement: "bottom",
        hide: true,
        modifiers: {
          flip: { behavior: ["bottom"] },
          preventOverflow: { priority: ["left", "right"], padding: 1 },
        },
        removeOnDestroy: true,
      },
      openPopperID: "",
      // Set bet lot rules for form validation purpose
      betlotRules: {
        stake: [
          {
            trigger: "change",
          },
        ],
      },
      currSessionStorage: "",
      dominoo1: "o3",
      dominoo3: "o1",
      dominoo4: "o5",
      dominoo5: "o4",
      dominoo6: "o7",
      dominoo7: "o6",
      dominoo8: "o9",
      dominoo9: "o8",
      dominoo10: "o11",
      dominoo11: "o10",
      taixiuo1: "o2",
      taixiuo2: "o1",
      taixiuo4: "o5",
      taixiuo5: "o4",
      hiloo3: "o4",
      hiloo4: "o3",
      fantanodd: "even",
      fantaneven: "odd"
    };
  },
  methods: {
    commaNumber(n) {
      let formattedOutput =
        n >= 1000000
          ? `${parseInt(n.toString()) / 1000000}M`
          : n >= 100000
          ? `${parseInt(n.toString()) / 1000}K`
          : n.toString();

      if (n >= 100000) {
        return formattedOutput;
      } else {
        return display_numeric(n);
      }
    },
    findStakeRecordSum(type) {
      let vm = this;
      let filteredRecords = filter(
        vm.currSessionStorage,
        item => parseInt(item.gID) === vm.gameData.gID && item.type === type
      )
      return sumBy(filteredRecords, "stake")
    },
    openPopper: function openPopper(a) {
      let vm = this;
      if (this.closeResponsePopperTimeout) {
        clearTimeout(this.closeResponsePopperTimeout);
        this.disabled = false;
      }

      if (this.disabled == true) {
        this.disabled = false;
      }

      this.currSessionStorage = JSON.parse(sessionStorage.getItem("stake-records"));

      let gameName = this.gameType.replace(/[^a-zA-Z ]/g, "");
      if (this.findStakeRecordSum(this[`${gameName}${a}`])) {
        this.displayErrorMessage("Cannot bet on both side.");
      }
      else {
        setTimeout(function() {
          if (vm.odd > 0 && !vm.disallowBetting) vm.openPopperID = a;
        }, 30);
      }
      
    },
    focusStake: function focusStake() {
      window.innerWidth > 767 &&
      window.innerHeight > 500 &&
      document.getElementById(
        "input-stake-" + this.gameData.gID + "-" + this.type
      ) != null
        ? document
            .getElementById(
              "input-stake-" + this.gameData.gID + "-" + this.type
            )
            .focus()
        : "";
    },
    closePopper: function closePopper(a) {
      this.$refs.popper.doClose();
    },
    popperHide: function popperHide(a) {
      this.$refs.popper.doDestroy(),
        this.openPopperID === a && (this.openPopperID = "");
    },
    async preCheckStake() {
      let betStake = numeric(this.numstake);
      if (this.rules) {
        if (betStake == 0) {
          return (betStake = "");
        } else if (betStake > this.rules.data.maxbet) {
          this.error = this.$t("general.ERROR_MAX_TO");

          let formData = new FormData();
          formData.append("game", this.game);
          formData.append("gID", this.gameData.gID);
          formData.append("drawID", this.gameData.drawID);
          formData.append("maxBet", this.rules.data.maxbet);
          formData.append("type", "Bet Addition");

          try {
            let res = await axios.post(recordMaxBetUrl, formData);
          } catch (e) {
            // console.log(e);
          }

          (this.setStakeTimeout = setTimeout(() => {
            this.setStake(this.rules.data.maxbet);
          }, 20)),
            (this.errorTimer = setTimeout(() => {
              this.error = null;
            }, 3000));
        }
      }
    },

    clearStake() {
      this.stake = "";
    },
    diceNumberOnClick(gameType) {
      this[`dice${this.group}SelectedType`] = gameType;
    },
    addStakeOnClick(stake) {
      this.stake = parseFloat(this.numstake === "" ? 0 : this.numstake) + stake;
      window.innerWidth > 767 &&
      document.getElementById(
        "input-stake-" + this.gameData.gID + "-" + this.type
      ) != null
        ? document
            .getElementById(
              "input-stake-" + this.gameData.gID + "-" + this.type
            )
            .focus()
        : "";
    },
    async setMaxStakeOnClick() {
      let formData = new FormData();
      formData.append("game", this.game);
      formData.append("gID", this.gameData.gID);
      formData.append("drawID", this.gameData.drawID);
      formData.append("maxBet", this.rules.data.maxbet);
      formData.append("type", "MaxBet Clicked");

      try {
        let res = await axios.post(recordMaxBetUrl, formData);
      } catch (e) {
        console.log(e);
      }
      this.stake = this.rules.data.maxbet;
    },
    okOnClick() {
      this.$refs.popper.doClose();
    },
    cancelOnClick() {
      this.$refs.popper.doClose();
    },
    // Set stake based on max or min bet of game
    setStake(a) {
      (this.stake = a), window.innerWidth > 767 ? this.focusStake() : "";
    },
    // Remove special character and alphabet character, remain numeric character
    isNumber: function isNumber(a) {
      a = a ? a : window.event;
      var b = a.which ? a.which : a.keyCode;

      if (b === 27) {
        // this.$parent.$parent.popperHide();
        this.$refs.popper.doClose();
      }
      return 31 < b && (48 > b || 57 < b) && (96 > b || 105 < b) && 46 !== b
        ? void a.preventDefault()
        : !0;
    },

    // When bet cell is click, start checking bet type from server to get corresponding bet info
    async checkBetType() {
      this.token = null;
      try {
        // Start sending request for retrieving drawing result
        let res = await axios.get(
          `${checkbetTypeUrl}&game=${this.game}&betID=${this.betID}&gID=${this.gameData.gID}`
        );
        let resData = res.data;
        // Set bet info for corresponding bet cell
        this.token = resData.token;
        this.rules = resData;
        this.gameBet = [];
        let i = this.rules.data.minbet;
        while (i < this.rules.data.maxbet) {
          this.gameBet.push(i);
          i = i * 5;
        }
        this.focusStake();
        this.lastStake();
      } catch (e) {
        console.log(e);
      }
    },

    betOnClick() {
      // Start form validation
      this.$refs["betlot-form"].validate(async (valid) => {
        // If form is valid and not empty string, start sending request to server
        if (
          valid &&
          this.numstake !== "" &&
          this.numstake >= this.rules.data.minbet &&
          this.preventDoubleEnter == 0
        ) {
          this.preventDoubleEnter = 1;
          let formData = new FormData();
          formData.append("productID", this.gameData.productID);
          formData.append("gID", this.gameData.gID);
          formData.append("drawID", this.gameData.drawID);
          formData.append("resultTime", this.gameData.resultTime);
          formData.append("betID", this.betID);
          formData.append("odds", this.odd);
          formData.append("stake", this.numstake);
          formData.append("token", this.token);

          try {
            this.pointerCell = "none";
            let res = await axios.post(placeBetUrl, formData);
            this.isLoading = false;

            let resData = res.data;
            this.preventDoubleEnter = 0;
            if (resData.error) {
              this.pointerCell = "auto";
              this.handleErrorCode(resData);
            } else {
              this.pointerCell = "auto";
              this.$root.lastStake = this.stake;
              this.isShowingResult = true;
              this.isLoading = true;

              this.responseMessage = this.$t("general.PLACE_SUCCESS");
              this.refNo = resData.ticket;

              this.$root.user.balance = isNaN(parseFloat(resData.data.balance))
                ? 0
                : parseFloat(resData.data.balance);

              setStakeRecord(this.gameData.gID, this.type, this.numstake);
              this.$emit("update-session-storage");

              this.closeResponsePopperTimeout = setTimeout(() => {
                if (typeof this.$refs.popper !== "undefined")
                  this.$refs.popper.doClose();
                this.clearCloseResponsePopperTimeout();
              }, 2000);
              // this.displaySuccessMessage(this.$t("general.PLACE_SUCCESS"));
            }
          } catch (e) {}
        } else if (this.numstake == "") {
          return (this.stake = this.rules.data.minbet); //if empty will default value
        } else if (this.numstake < this.rules.data.minbet) {
          this.error = this.$t("general.ERROR_MIN_TO");
          (this.setStakeTimeout = setTimeout(() => {
            return (this.stake = this.rules.data.minbet);
          }, 20)),
            (this.errorTimer = setTimeout(() => {
              this.error = null;
            }, 3000));
        }
      });
    },
    handleErrorCode(errorCode) {
      // Map error code to display correct error message
      switch (errorCode.error) {
        case 100:
          this.displayErrorMessage(this.$t("general.ERROR_MIN_TO"));
          break;
        case 101:
          this.displayErrorMessage(this.$t("general.ERROR_MAX_TO"));
          break;
        case 102:
          this.displayErrorMessage(this.$t("general.ERROR_MAX_DR"));
          break;
        case 103:
          this.displayErrorMessage(
            this.$t("general.ERROR_MAX_BTDR") +
              " ( Max Bet " +
              display_numeric(errorCode.remaining) +
              ")"
          );
          break;
        case 123:
          this.displayErrorMessage(this.$t("general.ERROR_XAMOUNT"));
          break;
        case 200:
          this.displayErrorMessage(this.$t("general.ERROR_NMB"));
          break;
        case 206:
          this.displayErrorMessage(this.$t("general.ERROR_206"));
          break;
        case 207:
          this.displayErrorMessage(this.$t("general.ERROR_207"));
          break;
        case 208:
          this.displayErrorMessage(this.$t("general.ERROR_208"));
          break;
        case 209:
          this.displayErrorMessage(this.$t("general.ERROR_209"));
          break;
        case 404:
          this.displayErrorMessage(this.$t("general.ERROR_GAME_UA"));
          break;
        default:
          this.displayErrorMessage(this.$t("general.PLACE_FAIL"));
      }
    },
    // Reset the whole state
    resetState() {
      this.clearStakeTimeout();

      each(betlotInitialState(), (val, key) => {
        this[key] = val;
      });
    },
    displayErrorMessage(content) {
      Message.error({
        duration: 3,
        content,
        top: 100,
        closable: true,
      });
    },
    displaySuccessMessage(content) {
      Message.success({
        duration: 3,
        content,
        closable: true,
      });
    },
    popperOnShow() {
      let vm = this;
      this.rules = null;
      this.clearCloseResponsePopperTimeout();
      this.checkBetType();
      this.resetState();
      // setTimeout(function () {
      //   vm.focusStake();
      //   vm.lastStake();
      // }, 30);
    },
    lastStake() {
      let vm = this;

      if (this.$root.lastStake != null) {
        setTimeout(function() {
          let rulesMax = vm.rules.data.maxbet;
          let rootLastStake = vm.$root.lastStake;
          if (rootLastStake > rulesMax) {
            rootLastStake = rulesMax;
          }
          vm.setStake(rootLastStake);
        }, 100);
      }
    },
    popperOnHide() {
      this.resetState();
    },
    clearStakeTimeout() {
      clearTimeout(this.setStakeTimeout);
      delete this.setStakeTimeout;
    },
    clearCloseResponsePopperTimeout() {
      clearTimeout(this.closeResponsePopperTimeout);
      delete this.closeResponsePopperTimeout;
    },
  },
};
</script>

<style lang="scss">
.form {
  padding: 5px 15px 45px 15px;
}

.input-form {
  height: 36px;
}

.inputs {
  display: inline-block;
  width: 100%;
  position: relative;
  margin-top: 10px;
}

.inputs .input-stake {
  width: 100%;
}

.inputs .input-stake a svg {
  height: 10px;
  width: 10px;
  fill: currentColor;
}

.inputs .input-stake a {
  height: 24px;
  border-radius: 3px;
  line-height: 24px;
  border: none;
  top: 5px;
  bottom: 5px;
  right: 8px;
  background: #413b3b;
  color: #ffffff;
  position: absolute;
  width: 24px;
  text-align: center;
  cursor: pointer;
  font-weight: 700;
}

.quickbet {
  margin: 5px -1px 0 -1px;
}

.quickbet .cell {
  padding-right: 2px;
  padding-bottom: 2px;
}

.small-up-4 > .cell {
  width: 25%;
}

.quickbet .cell a {
  background: #342f2f;
  color: #ffffff;
  font-weight: bold;
  line-height: 28px;
  height: 28px;
  border-right: none;
  font-size: 10px;
  text-align: center;
  white-space: nowrap;
  display: block;
  cursor: pointer;
  margin: 1px;
  border-radius: 3px;
  width: 100%;
}

.quickbet .cell a.max {
  background: rgb(2, 136, 85);
  background: -moz-linear-gradient(45deg, #0d6193 0%, #62d6e6 100%);
  background: -webkit-linear-gradient(45deg, #0d6193 0%, #62d6e6 100%);
  background: linear-gradient(45deg, #0d6193 0%, #62d6e6 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#0D6193', endColorstr='#62D6E6',GradientType=1 );
}

.quickbet .cell a:hover {
  background: #196cbb;
  font-weight: bold;
  color: #ffffff;
}

.quickbet .cell a.max:hover {
  background: rgb(209, 240, 108);
  background: -moz-linear-gradient(45deg, #62d6e6 0%, #0d6193 100%);
  background: -webkit-linear-gradient(45deg, #62d6e6 0%, #0d6193 100%);
  background: linear-gradient(45deg, #62d6e6 0%, #0d6193 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#62D6E6', endColorstr='#0D6193',GradientType=1 );
}

.popper {
  width: 250px;
  text-align: left;
  display: inline-block;
  border-radius: 5px;
  position: absolute;
  line-height: 16px;
  font-size: 14px;
  font-weight: 400;
  z-index: 200000;
  -moz-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  background: #3e3838 url(../../assets/images/common/popoverbg.png) top center
    no-repeat;
  color: #fff;
  border: none;
}

.bet-choices {
  margin-top: 10px;
}

.bet-choices .cancel-button {
  font-size: 12px;
  border: 1px solid #b9b9b9;
  background: transparent;
  color: #fff;
  font-weight: bold;
  line-height: 34px;
  height: 34px;
  width: 48%;
  margin: 0 1%;
  float: left;
  text-align: center;
  border-radius: 3px;
}

.bet-choices .cancel-button:hover {
  background: rgb(194, 35, 56);
  border: 1px solid rgb(194, 35, 56);
}

.bet-choices .bet-button {
  cursor: pointer;
  font-size: 12px;
  border: 1px solid rgb(42, 115, 226);
  background: #1d65ad;
  color: #fff;
  font-weight: bold;
  line-height: 30px;
  height: 34px;
  width: 48%;
  margin: 0 1%;
  float: right;
  text-align: center;
  border-radius: 3px;
  padding: 0px;
}

.bet-choices .bet-button:hover {
  background: #dcad58;
  border: 1px solid #dcad58;
  color: #fff;
  // line-height: 32px;
  line-height: 30px;
}

.bet-choices .bet-button.alert {
  background: rgb(194, 35, 56);
}

@keyframes loading-icon {
  0% {
    transform: rotate(0);
    animation-timing-function: cubic-bezier(0.9, 0.5, 0.9, 0.9);
  }
  50% {
    transform: rotate(900deg);
    animation-timing-function: cubic-bezier(50, 50, 100, 50);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading {
  background: #e2e7f0;
}

.loading-icon {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.loading-icon:after {
  content: " ";
  display: block;
  border-radius: 50%;
  width: 0;
  height: 0;
  margin: 0;
  box-sizing: border-box;
  border: 20px solid #fff;
  border-color: #242f4d transparent #283a69 transparent;
  animation: loading-icon 1.8s infinite;
}

.input-stake a:hover {
  background: #413b3b;
  color: #fed943;
}

.betlot-popper-header {
  padding: 13px 15px;
  opacity: 0.9;
  font-size: 12px;
  padding-bottom: 0px;
}

.betlot-title {
  text-transform: uppercase;
  color: #4ebaf1;
  font-size: 14px;
}

.betlot-draw-no {
  color: white;
  display: block;
  font-size: 12px;
}

.betlot-header-game {
  font-size: 10px;
  color: white;
}

.betlot-game-title {
  font-size: 13px;
  font-weight: bold;
}

.betlot-header-odd {
  color: white;
}

.betlot-bet-buttons {
  margin: 10px;
}

.betlot-bet-buttons-col {
  color: black;
  font-weight: bold;
  flex: 1;
  cursor: pointer;
}

.betlot-actions-components {
  margin: 0 10px;
}

.betlot-actions-components-input {
  font-weight: bold;
  color: #ffffff;
  border: none;
  background: #342f2f;
  height: 34px;
  line-height: 34px;
  padding: 0 37px 0 7px;
  text-align: right;
  width: 100%;
  border-radius: 4px;
}

.betlot-actions-components-button {
  background: #235ac2;
  color: #fff;
  font-weight: bold;
  line-height: 34px;
  height: 34px;
  display: inline-block;
  padding: 0 15px;
  cursor: pointer;
  font-size: 12px;
  margin-top: 5px;
  width: 100%;
  text-align: center;
  border: 1px solid #347ceb;
  border-radius: 3px;
}

.betlot-actions-components-button:hover {
  color: #fff;
}

.betlot-bet-info {
  border-radius: 3px;
  font-weight: bold;
  font-size: 12px;
  line-height: 20px;
  background: #342f2f;
  padding: 5px;
  color: #ffffff;
  margin-top: 10px;
}

.betlot-bet-info .error {
  color: #c22338;
  font-size: 14px;
  margin-bottom: 8px;
}

.betlot-bet-info-figure {
  font-weight: bold;
  font-size: 16px;
  color: $tai-xiu-theme-color-4;
}

.betlot-bet-info-description {
  color: $header-dark-color;
  font-weight: bold;
}

.betlot-bet-response {
  color: #339933;
  padding: 5px 15px 8px 15px;
}

.betlot-bet-response-message {
  margin-top: 10px;
  font-size: 14px;
}

.betlot-bet-response-ref-no {
  margin-bottom: 5px;
  font-size: 11px;
}

.popper[x-placement^="bottom"] {
  margin-top: 0px;
}

.popper[x-placement^="bottom"] .popper__arrow {
  border-color: transparent transparent #3e3838 transparent;
}
.betlot-counter span {
  font-size: 14px;
  color: #b6cade;
  font-weight: bold;
}

.betlot-counter .betlot-counter-colon {
  color: #b6cade;
  background: transparent;
  text-align: center;
  padding: 0;
  width: auto;
}

.betlot-rebet-section {
  padding: 5px 15px 35px 15px;
}

.betlot-rebet-last-bet {
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
  color: white;
  font-size: 13px;
}

.betlot-rebet-summary {
  border-radius: 5px;
  background: #342f2f;
  padding: 12px;
}

.betlot-rebet-summary-odd {
  font-weight: bold;
  color: white;
}

.summary .error {
  color: #c22338;
  font-size: 14px;
  margin-bottom: 8px;
}

.summary_value {
  font-size: 12px;
  font-weight: bold;
  color: #4ebaf1;
  float: right;
}

.rebet-button {
  padding: 10px;
}

.inputs input:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}

.betlot-popper .ivu-divider-horizontal {
  margin: 10px 0;
}

.popper .ivu-row-flex-space-between {
  margin-bottom: 7px;
}

.betlot-bet-types-buttons-section {
  margin: 10px;
}

.betlot-bet-types-buttons.ivu-btn.ivu-btn-default {
  border: transparent;
}

.betlot-bet-types-buttons.active-type {
  background-color: $tai-xiu-theme-color-3;
  color: $tai-xiu-theme-color-5;
}

.betlot-bet-types-buttons.active-type.ivu-btn.ivu-btn:hover {
  background-color: $tai-xiu-theme-color-3;
  color: $tai-xiu-theme-color-5;
}

.betlot-bet-chips {
  height: intrinsic;
}

.confirmbet {
  font-size: 12px;
  text-align: justify;
  color: red;
}

.bet-checking {
  text-align: left;
  color: red;

  input {
    margin: 0 3px;
  }

  label {
    position: relative;
    top: -2px;
  }
}

@media screen and (max-width: 640px) {
  .bet-checking {
    text-align: center;
  }
}
</style>
